import { render, staticRenderFns } from "./createLicence.vue?vue&type=template&id=323979c6"
import script from "./createLicence.vue?vue&type=script&lang=js"
export * from "./createLicence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports